export default "__VITE_ASSET__DqwABBIY__"